import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Only use StrictMode in production to avoid React Three Fiber issues with dev tools
const AppWrapper = process.env.NODE_ENV === 'production' 
  ? <React.StrictMode><App /></React.StrictMode>
  : <App />;

root.render(AppWrapper);
